import { Diamond } from "@src/types/DiamondDetail";
import { CollectionMenuItem } from "@src/types/models";
import { ProductCategory } from "@utils/constants";
import {
  getTwoProductProperty,
  itemLocation,
} from "@utils/product/productProperties";
import currency from "currency.js";
import { GlobalEnum } from "@utils/constants";
import { colorStringForShort, CustomisationKey } from "@scenes/pdp/types";
import { FilterStructure } from "@scenes/searchResults/types";
import { StockItemRequestClass } from "@src/types/HistoryRequest";
import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";
import { CartItem } from "@src/types/CartItemListResponse";
import { PriceModes } from "../PriceModeCard/types";
import { StoneType } from "@scenes/bulk-request/Utils";
import {
  isLooseParcel,
  isPair,
  isMeleeItem,
  isParcel,
} from "@utils/product/productValidators";
import {
  formatNumberWithPrecision,
  percent,
} from "@utils/product/productFormatters";
import { SearchResultsAndFavoritesEnum } from "@utils/product/searchResultConstants";

export type SearchResultTabletProps = {
  mItem?: Diamond;
  menuOptions: Array<CollectionMenuItem>;
  menuOptionSelected?: any;
  checkBoxSelection: any;
  ismItemChecked: boolean;
  productType: ProductCategory;
  handleItemClick?: any;
  favoriteClickedFunction?: any;
  index?: number;
  removeFavorite?: boolean;
  fromBulkList?: boolean;
  priceMode?: any;
  customizeColumnParams?: FilterStructure[];
  userCurrency?: any;
  productPrefix?: string;
  fromRequestDetail?: boolean;
  sectionName?: string;
  handleLinkClick?: any;
  selectedStoneType?: StoneType;
  testID?: string;
  dataTestId?: string;
};

export type SearchResultTabletHeaderProps = {
  mItem?: Diamond;
  stockItemRequest?: StockItemRequestClass;
  checkBoxSelection?: any;
  ismItemChecked?: boolean;
  listMargin?: number;
  productType: ProductCategory;
  onSortChange?: (sortingPayload: any) => void;
  sortingOptions?: any;
  sortType?: any;
  showCheckbox?: any;
  showFavorite?: boolean;
  fromBulkList?: boolean;
  fromRequestDetail?: boolean;
  customizeColumnParams?: FilterStructure[];
  showListPrice?: boolean;
  request_type?: string;
  hasAnyOfferDetails?: boolean;
  isTotalOfferDiscountApplied?: boolean;
  viewType?: string;
  requestType?: string;
  isTotalOfferPriceApply?: boolean;
  sectionName?: string;
  selectedStoneType?: StoneType;
  useMobileWebView?: boolean;
};

export type SearchResultListTypes = {
  listExpanded: boolean;
  mItem?: Diamond;
  menuOptions: Array<CollectionMenuItem>;
  menuOptionSelected: any;
  checkBoxSelection: any;
  ismItemChecked: boolean;
  handleItemClick?: any;
  favoriteClickedFunction?: any;
  productType: string;
  showAvailabilityDot?: boolean;
  sectionName?: SearchFilterTypeEnum;
  handleLinkClick?: any;
};

export type BulkRequestItemComponentTypes = {
  mItem?: CartItem;
  productType: string;
  changeEditCommentModalIndex?: any;
  fromRequestDetail?: boolean;
  stockItemRequest?: StockItemRequestClass;
  showCheckbox?: boolean;
  showItemStatus?: boolean;
  checkboxDisabled?: boolean;
  checkBoxSelection?: any;
  hideBorder?: boolean;
  fromRequestModify?: boolean;
  setShowLoader?: boolean;
  showRemoveIcon?: boolean;
  refetchCartData?: any;
  onPress: () => void;
  orderCartRequest?: boolean;
  showListPrice?: boolean;
  isTotalOfferDiscountApplied?: boolean;
  viewType?: string;
  requestType?: string;
  hasAnyOfferDetails?: boolean;
  fromBulkList?: boolean;
  childValues?: [];
  editBulkItem?: boolean;
  onCloseEditBulkItem?: () => void;
  isChildRequest?: boolean;
  selectedItems?: any;
  priceMode?: PriceModes;
  isBuilderItem?: boolean;
  stoneItem1?: Diamond;
  stoneItem2?: Diamond;
  stoneItemOnPress?: (id?: string) => void;
  configDetails?: any;
  applyMarginTop?: boolean;
  applyMarginBottom?: boolean;
  stoneType?: StoneType;
  saveBulkItemDetails?: any;
  showRequestItemFromSupplier?: boolean;
  deepLink?: string;
  showRequestItemFromSupplierStone1?: boolean;
  deepLinkStone1?: string;
  testID?: string;
  dataTestId?: string;
};

export type ImageComponentWithSummaryTypes = {
  mItem?: Diamond;
  isCheckboxVisible?: boolean;
  checkboxDisabled?: boolean;
  checkBoxSelection?: any;
  ismItemChecked?: boolean;
  productType: string;
  showAvailabilityDot?: boolean;
  fromBulkList?: boolean;
  showListPrice?: boolean;
  isTotalOfferDiscountApplied?: boolean;
  requestType?: string;
  viewType?: string;
  hasAnyOfferDetails?: boolean;
  stockItemRequest?: StockItemRequestClass;
  fromRequestModify?: boolean;
  editBulkItem?: boolean;
  priceMode?: PriceModes;
  fromSearchResult?: boolean;
  sectionName?: SearchFilterTypeEnum;
  backGroundColor?: string;
  borderRadius?: boolean;
  height?: string;
  isBuilderItem?: boolean;
  stoneType?: StoneType;
  fromOrderRequest?: boolean;
};

export type OptionsComponentForSearchResultType = {
  mItem?: Diamond;
  menuOptions: Array<CollectionMenuItem>;
  menuOptionSelected: any;
  favoriteClickedFunction?: any;
  productType: string;
};

export type PriceContainerTypes = {
  mItem?: Diamond;
  priceDetailsDataOptions?: any[];
  fromBulkList?: boolean;
  viewType?: string;
  isTotalOfferDiscountApplied?: boolean;
  showListPriceDetail?: boolean;
  requestType?: string;
  hasAnyOfferDetails?: boolean;
  fromRequestDetail?: boolean;
  childValues?: [];
  stockType?: string;
  fromRequestModify?: boolean;
  saveBulkItemDetails?: (id: number, details: any) => void;
};

export type SecondSectionWithFilteredDataTypes = {
  listExpanded?: boolean;
  mItem?: Diamond;
  productType: string;
  fromBulkList?: boolean;
  priceDetailsDataOptions?: any[];
  editBulkItem?: boolean;
  sectionName?: string;
  handleLinkClick?: any;
  fromRequestPairs?: boolean;
  stoneType?: StoneType;
  fromRequestDetail?: boolean;
  isLooseParcel?: boolean;
};

export type OptionsComponentForBulkRequestEditTypes = {
  mItem?: Diamond;
  changeEditCommentModalIndex: any;
  orderCart?: boolean;
  fromModifyScreen?: boolean;
  stoneItem1?: any;
  stoneItem2?: any;
  isBuilderItem?: boolean;
  testID?: string;
  dataTestId?: string;
};

export type CommentsComponentTypes = {
  comments?: string;
};

export enum SortingOptions {
  ASCENDING_SORT = "ASC",
  DESCENDING_SORT = "DESC",
  DEFAULT_SORT = "DEFAULT",
}

export const formatItemValue = (
  isCustomApp: boolean,
  key: string,
  item?: Diamond,
  userCurrency?: string,
  userInfo?: any,
  translation?: any,
  isShortValue?: boolean,
  allowQuantity?: boolean
) => {
  switch (key) {
    case "color":
      return colorStringForShort(isShortValue ? isShortValue : false, item);
    case SearchResultsAndFavoritesEnum.HEARTS_AND_ARROWS:
      return translation &&
        item?.hearts_and_arrows ===
          SearchResultsAndFavoritesEnum.HEARTS_AND_ARROWS_VALUE
        ? translation("global.text.yes")
        : translation("global.text.no");
    case "on_hand":
      switch (item?.on_hand) {
        case GlobalEnum.ON_HAND:
          return userInfo?.onHandText(GlobalEnum.ON_HAND);
        case GlobalEnum.PLEASE_EMAIL:
          return userInfo?.onHandText(GlobalEnum.PLEASE_EMAIL);
        default:
          return userInfo?.onHandText(GlobalEnum.OUT_ON_MEMO);
      }
    case "available":
      switch (item?.on_hand) {
        case GlobalEnum.ON_HAND:
          return userInfo?.onHandText(GlobalEnum.ON_HAND);
        case GlobalEnum.PLEASE_EMAIL:
          return userInfo?.onHandText(GlobalEnum.PLEASE_EMAIL);
        default:
          return userInfo?.onHandText(GlobalEnum.OUT_ON_MEMO);
      }
    case "total_sales_price":
      return item?.special_price
        ? currency(item.special_price, {
            symbol: userCurrency,
            precision: userInfo?.roundUpPrices() && !isMeleeItem(item) ? 0 : 2,
          }).format()
        : isCustomApp && isLooseParcel(item) && item?.hide_total_sales_price
        ? "-"
        : item?.total_sales_price
        ? parseFloat(item.total_sales_price) === 0
          ? "-"
          : currency(
              allowQuantity && item?.quantity
                ? parseFloat(item.total_sales_price) * parseFloat(item.quantity)
                : item.total_sales_price,
              {
                symbol: userCurrency,
                precision: isCustomApp
                  ? userInfo?.roundUpPrices() && !isMeleeItem(item)
                    ? 0
                    : 2
                  : 0,
              }
            ).format()
        : "-";
    case "retail_price":
      return item?.retail_price
        ? currency(item.retail_price, {
            symbol: userCurrency,
            precision: userInfo?.roundUpPrices() && !isMeleeItem(item) ? 0 : 2,
          }).format()
        : "-";
    case CustomisationKey.price_per_carat:
      return isCustomApp && isLooseParcel(item) && item?.hide_price_per_carat
        ? "-"
        : item?.price_per_carat
        ? parseFloat(item.price_per_carat) === 0
          ? "-"
          : currency(item.price_per_carat, {
              symbol: userCurrency,
              precision: 0,
            }).format()
        : "-";
    case CustomisationKey.discount_percent:
      return item?.discount_percent && parseFloat(item.discount_percent) !== 0
        ? percent(
            currency(item?.discount_percent, {
              symbol: "",
              precision: 2,
            }).format()
          )
        : "-";

    case "locations":
      return item?.locations ? itemLocation(item) : "-";
    case "depth_percent":
      return percent(item?.depth_percent);
    case "offer_discount_percent":
      return percent(item?.offer_discount_percent);

    case "table_percent":
      return percent(item?.table_percent);

    case "crown_height":
      return percent(item?.crown_height);

    case "crown_angle":
      return item?.crown_angle ? item?.crown_angle + "°" : "-";

    case "crown":
      return getTwoProductProperty(
        item?.crown_height ?? "",
        "%",
        item?.crown_angle ?? "",
        "°"
      );

    case "pavilion_depth":
      return percent(item?.pavilion_depth);

    case "pavilion_angle":
      return item?.pavilion_angle ? item?.pavilion_angle + "°" : "-";

    case "pavilion":
      return getTwoProductProperty(
        item?.pavilion_depth ?? "",
        "%",
        item?.pavilion_angle ?? "",
        "°"
      );

    case "rapnet_price":
      return item?.rapnet_price
        ? currency(item.rapnet_price, {
            symbol: userCurrency,
            precision: userInfo?.roundUpPrices() && !isMeleeItem(item) ? 0 : 2,
          }).format()
        : "-";
    case "stock_num":
      return item?.stock_num
        ? (!isCustomApp && !userInfo?.user?.custom_theme ? "VDB-" : "") +
            item?.stock_num
        : "-";
    case "size":
      return item?.size
        ? parseFloat(item?.size) === 0
          ? "-"
          : item.size
        : "-";
    case CustomisationKey.live_rapa_rate: {
      return item?.live_rapa_rate
        ? currency(item.live_rapa_rate, {
            symbol: userCurrency,
            precision: userInfo?.roundUpPrices() && !isMeleeItem(item) ? 0 : 2,
          }).format()
        : "-";
    }
    case "comment":
      return item?.cert_comment || "-";
    case "parcel_stones":
      return item?.parcel_stones
        ? parseFloat(item?.parcel_stones) === 0
          ? "-"
          : item?.parcel_stones
        : "-";
    case "meas_length":
      return item?.meas_length
        ? parseFloat(item?.meas_length) === 0
          ? "-"
          : formatNumberWithPrecision(item?.meas_length, { precision: 2 })
        : "-";
    case "pair":
      return isPair(item) ? "Yes" : "-";
    case "stone_type":
      return isPair(item)
        ? translation("productDetail.pair.text", "Pair")
        : isParcel(item)
        ? translation("productDetail.parcels.text", "Parcel")
        : translation("productDetail.singleStones.text", "Single Stone");
    case "special_price":
      return item?.special_price
        ? isCustomApp && isLooseParcel(item) && item?.hide_total_sales_price
          ? "-"
          : item?.total_sales_price
          ? parseFloat(item.total_sales_price) === 0
            ? "-"
            : currency(item.total_sales_price, {
                symbol: userCurrency,
                precision: isCustomApp
                  ? userInfo?.roundUpPrices() && !isMeleeItem(item)
                    ? 0
                    : 2
                  : 0,
              }).format()
          : "-"
        : "-";
    case "total_amount":
      return item?.total_amount
        ? currency(item.total_amount, {
            symbol: userCurrency,
            precision: userInfo?.roundUpPrices() ? 0 : 2,
          }).format()
        : "-";
    default:
      const resolvedValue = key?.includes(".")
        ? key?.split(".")?.reduce((acc, k) => acc?.[k], item)
        : item?.[key as keyof typeof item];
      return resolvedValue || "-";
  }
};

export type TooltipTextProps = {
  text: string;
  tooltip: string;
  color: string;
  type: string;
  enableTooltip: boolean;
  isAvailableStatusView?: boolean;
  isImageTooltip?: boolean;
  defaultWidth?: string | number;
  textAlignment?: string;
  productType?: string;
  tooltipPosition?: any;
  imageHovered?: boolean;
  hoverColor?: string;
};
